import classnames from "classnames";
import React, { forwardRef } from "react";

import buttonStyles from "@/styles/Button.module.scss";

import type ButtonProps from "../../types/Button.js";

const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const {
    className,
    fillColor,
    fillMainColor,
    fillGray,
    fillLightGray,
    fillCautionColor,
    fillTransparentGray,
    borderBlue,
    borderGray,
    borderLight,
    borderCaution,
    fontFixed,
    fontBold,
    large,
    medium,
    small,
    largeFont,
    favBtn,
    favBtnWithLabel,
    listRow,
    scale,
    inline,
    transparent,
    loading,
    hoverAnimation,
    bgColor,
    withIcon,
    disabledWithGray,
    ...restProps
  } = props;

  return (
    <button
      ref={ref}
      className={classnames(buttonStyles.btn, className, {
        [buttonStyles.fillCautionColor]: fillCautionColor,
        [buttonStyles.borderGray]: borderGray,
        [buttonStyles.fontFixed]: fontFixed,
      })}
    >
      {props.children}
    </button>
  );
});

Button.displayName = "Button";
export default Button;
